// The loading screen, everywhere: the pulsing Sourdough logo from the boot
// splash in public/index.html, with a caption that says what's loading.
//
// fullScreen matches the boot splash exactly (same logo size, ground, type),
// so the hand-off from the HTML splash to a lazily loaded page is seamless.
// Otherwise it's a compact block that sits inside a page or card.

import React from "react";

const PUB = process.env.PUBLIC_URL || "";

const KEYFRAMES = `
@keyframes brand-loader-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.55; } }
@media (prefers-reduced-motion: reduce) { .brand-loader-img { animation: none !important; } }
`;

export function BrandLoader({
  text = "Loading…",
  fullScreen = false,
  size,
  padding,
}: {
  text?: React.ReactNode;
  fullScreen?: boolean;
  size?: number;
  padding?: string | number;
}) {
  const px = size ?? (fullScreen ? 96 : 44);
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={fullScreen ? {
        position: "fixed", inset: 0, zIndex: 1, display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center", gap: 12, background: "#f5f5f5",
      } : {
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", gap: 10, padding: padding ?? "40px 16px", textAlign: "center",
      }}
    >
      <style>{KEYFRAMES}</style>
      <img
        className="brand-loader-img"
        src={`${PUB}/sourdough-logo.png`}
        alt=""
        width={px}
        height={px}
        style={{ animation: "brand-loader-pulse 1.6s ease-in-out infinite" }}
      />
      {text && (
        <div style={fullScreen
          ? { font: "600 17px 'DM Sans', system-ui, sans-serif", color: "#374151" }
          : { fontSize: 13, fontWeight: 600, color: "var(--m-ink-3, #6B7280)" }}>
          {text}
        </div>
      )}
    </div>
  );
}

export default BrandLoader;
